import moment from 'moment';

import { createFile } from '#apps/client-web/features/file-storage/helpers';
import { type FileContent } from '#apps/client-web/features/file-storage/services/file-storage';
import { parseIntOrUndefined } from '#apps/client-web/utils/helpers';

import { type Attachment } from '#packages/data-collection/models/common/attachment';
import { type AuditMechanicalFormEntry } from '#packages/data-collection/models/audit-mechanical-form';

import { type EditAuditFormMechanicalEntryData } from './types';

export const fromFormData = (
  formData: EditAuditFormMechanicalEntryData,
  attachments?: Attachment[],
): Omit<AuditMechanicalFormEntry, 'manufactureDate'> & {
  manufactureDate?: string;
} => ({
  system: formData.system,
  location: formData.location,
  serviceAreaOrEquipment: formData.serviceAreaOrEquipment,
  type: formData.type,
  tag: formData.tag,
  quantity: parseIntOrUndefined(formData.quantity),
  make: formData.make,
  model: formData.model,
  powerRating: formData.powerRating,
  ratingUnit: formData.ratingUnit,
  ratingSource: formData.ratingSource,
  fuelType: formData.fuelType,
  efficiency: parseIntOrUndefined(formData.efficiency),
  efficiencySource: formData.efficiencySource,
  ventilationRate: parseIntOrUndefined(formData.ventilationRate),
  serialNumber: formData.serialNumber,
  manufactureDate: formData.manufactureDate
    ? moment(formData.manufactureDate).toISOString()
    : undefined,
  hours: parseIntOrUndefined(formData.hours),
  control: formData.control,
  other: formData.other,
  attachments,
});

export const toFormData = (
  entryData: AuditMechanicalFormEntry | undefined,
  files?: (FileContent | undefined)[],
): Partial<EditAuditFormMechanicalEntryData> => ({
  system: entryData?.system,
  type: entryData?.type,
  location: entryData?.location,
  tag: entryData?.tag,
  serviceAreaOrEquipment: entryData?.serviceAreaOrEquipment,
  quantity: entryData?.quantity?.toString(),
  make: entryData?.make,
  model: entryData?.model,
  powerRating: entryData?.powerRating,
  ratingUnit: entryData?.ratingUnit,
  ratingSource: entryData?.ratingSource,
  fuelType: entryData?.fuelType,
  efficiency: entryData?.efficiency?.toString(),
  efficiencySource: entryData?.efficiencySource,
  ventilationRate: entryData?.ventilationRate?.toString(),
  serialNumber: entryData?.serialNumber,
  manufactureDate: entryData?.manufactureDate?.format('YYYY-MM-DD'),
  hours: entryData?.hours?.toString(),
  control: entryData?.control,
  other: entryData?.other,
  attachments: entryData?.attachments?.map((attachment, index) => ({
    ...attachment,
    file: createFile({
      content: files![index]!,
      name: attachment.name,
      mimeType: attachment.mimeType,
    }),
  })),
});
